module.exports = __webpack_public_path__ + "static/media/baby.0067271e.svg";